module.exports = __webpack_public_path__ + "media/images/country_flags/mg-e3e05b81b8a7481d976e6a42e4c0756b.png";